import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { FullUserFragment } from 'graphql.generated';
import { ActionSource } from 'src/app/state/action-sources';

export const NewOpportunitySearchCustomersDialogActions = createActionGroup({
  source: ActionSource.NEW_OPPORTUNITY,
  events: {
    'Repeat Customer Button Clicked': emptyProps(),
    'Search Customers Dialog Opened': props<{ query: string }>(),
    'Search Customers Dialog Closed': emptyProps(),
    'Search Query Changed': props<{ query: string }>(),
    'Search Customers Started': emptyProps(),
    'Search Customers Success': props<{ customers: FullUserFragment[] }>(),
    'Search Customers Error': props<{ error: Error }>(),
    'Customer Row Clicked': props<{ customer: FullUserFragment }>(),
  },
});
